import React from 'react';
import { Link, Redirect } from "react-router-dom";
import {
    Card,
    Row,
    Col,
    Form,
    Input,
    InputNumber,
    Button,
    Select,
    DatePicker,
    message,
    Alert,
    Spin,
    Switch,
    Typography,
    Tag,
    Space,
} from 'antd';
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    SettingOutlined,
    ArrowLeftOutlined,
    CalendarOutlined,
    PercentageOutlined,
    TagOutlined,
    CarOutlined,
    SaveOutlined,
    EditOutlined,
    PlusCircleOutlined,
} from '@ant-design/icons';
import moment from 'moment';

import Config from '../../Config';
import { connect } from 'react-redux';
import {
    initHandler,
    ajaxViewHandler,
    ajaxHandler,
    setConfig,
    extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
    title: 'Pengaturan Diskon',
    apiUrl: {
        preview: "master/api/discount/",
        fungsi:  "master/api/fungsi/",
        layanan: "master/api/layanan/",
    },
    pageUrl: {
        data: '/admin/pengaturan/diskon/'
    },
    breadCrumb: [
        (<span><SettingOutlined /> Pengaturan</span>),
        'Diskon',
        'Form'
    ]
};

const config = new Config();

const SWITCH_FIELDS = [
    { name: 'progressif',  label: 'Progressif',  color: '#722ed1' },
    { name: 'plat_merah',  label: 'Plat Merah',  color: '#f5222d' },
    { name: 'plat_putih',  label: 'Plat Putih',  color: '#595959' },
    { name: 'plat_kuning', label: 'Plat Kuning', color: '#faad14' },
];

const PERSEN_GROUPS = [
    {
        label: 'BBNKB I',
        color: '#1890ff',
        bg: '#e6f7ff',
        fields: [
            { name: 'pokok_bbnkb_i', label: 'Pokok' },
            { name: 'denda_bbnkb_i', label: 'Denda' },
        ]
    },
    {
        label: 'PKB Berjalan',
        color: '#52c41a',
        bg: '#f6ffed',
        fields: [
            { name: 'pokok_pkb', label: 'Pokok' },
            { name: 'denda_pkb', label: 'Denda' },
        ]
    },
    {
        label: 'PKB Tunggak',
        color: '#fa8c16',
        bg: '#fff7e6',
        fields: [
            { name: 'tunggakan_pokok_pkb', label: 'Pokok' },
            { name: 'tunggakan_denda_pkb', label: 'Denda' },
        ]
    },
    {
        label: 'SWDKLLJ Berjalan',
        color: '#13c2c2',
        bg: '#e6fffb',
        fields: [
            { name: 'pokok_swdkllj', label: 'Pokok' },
            { name: 'denda_swdkllj', label: 'Denda' },
        ]
    },
    {
        label: 'SWDKLLJ Tunggak',
        color: '#eb2f96',
        bg: '#fff0f6',
        fields: [
            { name: 'tunggakan_pokok_swdkllj', label: 'Pokok' },
            { name: 'tunggakan_denda_swdkllj', label: 'Denda' },
        ]
    },
];

class FormDiskon extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            isRedirect: false,
            errComponent: false,
            errTitle: '',
            errMsg: '',
            loadingButton: false,
            loadingFungsi: null,
            listFungsi: [],
            loadingLayanan: null,
            listLayanan: [],
            aksi: 'tambah',
            method: 'post',
            idLama: '',
            progressif:  false,
            plat_merah:  false,
            plat_putih:  false,
            plat_kuning: false,
        };
    }

    UNSAFE_componentWillMount() { this.props.initHandler(); }

    componentDidMount() { this.loadMasterList(); }

    loadMasterList() {
        const rule = [
            {
                destination: {
                    stateProgressName: "loadingFungsi",
                    endPoint: configClass.apiUrl.fungsi,
                    stateDestination: "listFungsi",
                    next: null,
                },
                nextDestination: null
            },
            {
                destination: {
                    stateProgressName: "loadingLayanan",
                    endPoint: configClass.apiUrl.layanan,
                    stateDestination: "listLayanan",
                    next: null,
                },
                nextDestination: null
            },
        ];
        this.setState({ errComponent: false });
        rule.forEach((item, index) => {
            this.getMasterList(item, index === rule.length - 1);
        });
    }

    async getMasterList(rule, isFinal = false) {
        const { destination, nextDestination } = rule;
        this.setState({ [destination.stateProgressName]: true });
        this.props.ajaxViewHandler("get", destination.endPoint)
            .then((action) => {
                const { isSuccess, responseMsg: data } = extractResult(action);
                if (isSuccess) {
                    if (data.count != undefined) {
                        const isSearching = destination.stateProgressName.includes("_searching");
                        const oldState = this.state[destination.stateDestination];
                        const newState = (oldState.length === 0 || isSearching)
                            ? data
                            : { count: data.count, next: data.next, previous: data.previous, results: [...oldState.results, ...data.results] };
                        this.setState({ [destination.stateDestination]: newState });
                    } else if (data.results != undefined) {
                        this.setState({ [destination.stateDestination]: data.results });
                    } else {
                        this.setState({ [destination.stateDestination]: Array.isArray(data) ? data : [data] });
                    }
                    if (isFinal && this.props.match.params.id != undefined) {
                        this.preview(this.props.match.params.id);
                    }
                } else {
                    this.setState({ errComponent: true });
                }
                this.setState({ [destination.stateProgressName]: false });
            })
            .catch(() => {
                message.error({ content: "gagal request data, coba lagi", duration: 2, key: "toast" });
                this.setState({ errTitle: "gagal request data master", [destination.stateProgressName]: false });
            });
        if (nextDestination) {
            this.getMasterList({ destination: nextDestination, nextDestination: nextDestination.next });
        }
    }

    async preview(id) {
        message.loading({ content: 'Memuat data...', duration: 0, key: 'toast' });
        this.props.ajaxViewHandler('get', configClass.apiUrl.preview + id)
            .then((action) => {
                const { isSuccess, responseMsg: data } = extractResult(action);
                if (isSuccess) {
                    this.formRef.current.setFieldsValue(data);
                    const dateRegex = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/;
                    const switchNames = SWITCH_FIELDS.map(f => f.name);
                    for (var key in data) {
                        if (dateRegex.test(data[key])) {
                            this.formRef.current.setFieldsValue({
                                [key + '_picker']: moment(data[key]),
                                [key]: moment(data[key]).format('DD-MM-YYYY'),
                            });
                        } else if (switchNames.includes(key)) {
                            this.setState({ [key]: data[key] });
                        }
                    }
                    message.destroy();
                    this.setState({ aksi: 'edit', method: 'put', idLama: id + '/' });
                } else {
                    const errTitle = 'Gagal memuat data';
                    this.setState({ errTitle, errMsg: data });
                    message.error({ content: errTitle, duration: 2, key: 'toast' });
                }
            }).catch(() => {
                message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
            });
    }

    handleSubmit = (values) => { this.postData(values); }

    async postData(datas) {
        message.loading({ content: 'Menyimpan...', key: 'toast' });
        this.setState({ loadingButton: true });
        this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, false, true)
            .then((action) => {
                this.setState({ loadingButton: false });
                const { isSuccess, responseMsg } = extractResult(action);
                if (isSuccess) {
                    message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
                    this.setState({ isRedirect: true });
                } else {
                    const errTitle = 'Gagal menyimpan data';
                    message.error({ content: errTitle, duration: 2, key: 'toast' });
                    this.setState({ errTitle, errMsg: responseMsg });
                }
            }).catch(() => {
                this.setState({ loadingButton: false });
                message.error({ content: 'Kesalahan jaringan, coba lagi', duration: 2, key: 'toast' });
            });
    }

    generateSelect(stateName, url, key, value) {
        if (this.state["loading" + stateName]) {
            return <img src={process.env.PUBLIC_URL + "/loading_crop.gif"} height="30" alt="loading" />;
        }
        const listData = this.state["list" + stateName];
        const items = listData.count != undefined ? listData.results : (Array.isArray(listData) ? listData : []);
        return (
            <Select
                showSearch
                placeholder={"Cari / Pilih " + stateName}
                optionFilterProp="children"
                onSearch={(val) => {
                    this.getMasterList({
                        destination: {
                            stateProgressName: "loading" + stateName + "_searching",
                            endPoint: url + "?search=" + val,
                            stateDestination: "list" + stateName,
                        },
                        nextDestination: null,
                    });
                }}
                onPopupScroll={(e) => {
                    e.persist();
                    const t = e.target;
                    if (t.scrollTop + t.offsetHeight === t.scrollHeight && listData && listData.next) {
                        this.getMasterList({
                            destination: {
                                stateProgressName: "loading" + stateName + "Paging",
                                endPoint: listData.next,
                                stateDestination: "list" + stateName,
                            },
                            nextDestination: null,
                        });
                    }
                }}
                allowClear
                style={{ width: "100%" }}
            >
                {this.state["loading" + stateName + "_searching"] && (
                    <Select.Option value=""><Spin size="small" /></Select.Option>
                )}
                {items.map((item) => (
                    <Select.Option key={item[key]} value={item[key]}>
                        {item[key]} — {item[value]}
                    </Select.Option>
                ))}
                {listData && listData.next && (
                    <Select.Option value=""><Spin size="small" /></Select.Option>
                )}
            </Select>
        );
    }

    generateMultiSelect(stateName, url, key, value) {
        if (this.state["loading" + stateName]) {
            return <img src={process.env.PUBLIC_URL + "/loading_crop.gif"} height="30" alt="loading" />;
        }
        const listData = this.state["list" + stateName];
        const items = listData.count != undefined ? listData.results : (Array.isArray(listData) ? listData : []);
        return (
            <Select
                mode="multiple"
                showSearch
                placeholder={"Pilih " + stateName}
                optionFilterProp="children"
                allowClear
                style={{ width: "100%" }}
            >
                {items.map((item) => (
                    <Select.Option key={item[key]} value={item[key]}>
                        {item[value]}
                    </Select.Option>
                ))}
            </Select>
        );
    }

    render() {
        if (this.state.isRedirect) return <Redirect to="/admin/pengaturan/diskon" />;

        const isEdit = this.state.aksi === 'edit';

        return (
            <div>
                <Helmet>
                    <title>{configClass.title + " | " + config.get_site_info().name}</title>
                    <style>{`
                        .form-diskon-wrap .ant-input,
                        .form-diskon-wrap .ant-input-number,
                        .form-diskon-wrap .ant-input-number-group-wrapper,
                        .form-diskon-wrap .ant-picker,
                        .form-diskon-wrap .ant-select-selector {
                            border-radius: 8px !important;
                        }
                        .form-diskon-wrap .ant-input-number-group-wrapper .ant-input-number {
                            border-radius: 8px 0 0 8px !important;
                        }
                        .form-diskon-wrap .ant-input-number-group-addon {
                            border-radius: 0 8px 8px 0 !important;
                        }
                        .form-diskon-wrap .ant-form-item-label > label {
                            font-weight: 600;
                            color: #374151;
                            font-size: 12px;
                        }
                        .form-diskon-wrap .ant-input:focus,
                        .form-diskon-wrap .ant-input-number-focused,
                        .form-diskon-wrap .ant-picker-focused,
                        .form-diskon-wrap .ant-select-focused .ant-select-selector {
                            border-color: #1e4d8a !important;
                            box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
                        }
                    `}</style>
                </Helmet>

                {/* ── Breadcrumb ─────────────────────────────── */}

                <Form
                    layout="vertical"
                    name="fdata"
                    onFinish={this.handleSubmit}
                    ref={this.formRef}
                    className="form-diskon-wrap"
                >
                    {/* ── Header ────────────────────────── */}
                    <div style={{
                        marginBottom: 16,
                        borderRadius: 10,
                        overflow: 'hidden',
                        background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
                        padding: '20px 24px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 16,
                        boxShadow: '0 4px 16px rgba(15,40,71,0.18)',
                    }}>
                        <div style={{
                            width: 52, height: 52, borderRadius: 14, flexShrink: 0,
                            background: 'rgba(255,255,255,0.15)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            {isEdit
                                ? <EditOutlined style={{ color: '#fff', fontSize: 24 }} />
                                : <PlusCircleOutlined style={{ color: '#fff', fontSize: 24 }} />
                            }
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
                                {isEdit ? 'Edit Diskon' : 'Tambah Diskon Baru'}
                            </div>
                            <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, marginTop: 3 }}>
                                {isEdit
                                    ? 'Perbarui konfigurasi persentase diskon'
                                    : 'Atur persentase diskon untuk setiap komponen pajak'}
                            </div>
                        </div>
                        <Link to={configClass.pageUrl.data}>
                            <Button
                                icon={<ArrowLeftOutlined />}
                                style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: 8, flexShrink: 0 }}
                            >
                                Kembali
                            </Button>
                        </Link>
                    </div>

                    {/* ── Alert Error ────────────────────────── */}
                    <ErrorAlertModal
                        visible={this.state.errMsg !== ''}
                        title={this.state.errTitle}
                        error={this.state.errMsg}
                        onClose={() => this.setState({ errTitle: '', errMsg: '' })}
                    />

                    {/* ── Informasi Dasar ─────────────────────── */}
                    <Card
                        style={{ marginBottom: 16, borderRadius: 8, border: '1px solid #f0f0f0' }}
                        title={
                            <Space>
                                <TagOutlined style={{ color: '#1890ff' }} />
                                <Text strong style={{ fontSize: 13 }}>Informasi Dasar</Text>
                            </Space>
                        }
                        headStyle={{ background: '#fafafa', borderRadius: '8px 8px 0 0', minHeight: 40 }}
                    >
                        <Row gutter={[16, 0]}>
                            <Col xs={24} sm={24} lg={12}>
                                <Form.Item
                                    label={<Text strong>Kode Fungsi</Text>}
                                    name="fungsi"
                                    rules={[{ required: true, message: 'Pilih kode fungsi' }]}
                                >
                                    {this.generateSelect("Fungsi", configClass.apiUrl.fungsi, "id", "nama")}
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} lg={12}>
                                <Form.Item
                                    label={<Text strong>Layanan PKB</Text>}
                                    name="layanan_array"
                                    rules={[{ required: true, message: 'Pilih minimal 1 layanan PKB' }]}
                                    extra="Layanan yang mendapat diskon PKB / BBNKB"
                                >
                                    {this.generateMultiSelect("Layanan", configClass.apiUrl.layanan, "id", "nama")}
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} lg={12}>
                                <Form.Item
                                    label={<Text strong>Layanan SWDKLLJ</Text>}
                                    name="layanan_swdkllj"
                                    rules={[{ required: true, message: 'Pilih minimal 1 layanan SWDKLLJ' }]}
                                    extra="Layanan yang mendapat diskon SWDKLLJ"
                                >
                                    {this.generateMultiSelect("Layanan", configClass.apiUrl.layanan, "id", "nama")}
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} lg={6}>
                                <Form.Item
                                    label={
                                        <Space size={4}>
                                            <CalendarOutlined style={{ color: '#52c41a' }} />
                                            <Text strong>Berlaku Mulai</Text>
                                        </Space>
                                    }
                                    name="mulai_dari_picker"
                                    rules={[{ required: true, message: 'Isi tanggal mulai' }]}
                                >
                                    <DatePicker
                                        placeholder="dd-mm-yyyy"
                                        format="DD-MM-YYYY"
                                        style={{ width: '100%' }}
                                        onChange={(_, dateString) => {
                                            this.formRef.current.setFieldsValue({ mulai_dari: dateString });
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item name="mulai_dari" style={{ display: 'none' }}>
                                    <Input type="hidden" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} lg={6}>
                                <Form.Item
                                    label={
                                        <Space size={4}>
                                            <CalendarOutlined style={{ color: '#f5222d' }} />
                                            <Text strong>Berlaku Sampai</Text>
                                        </Space>
                                    }
                                    name="sampai_dengan_picker"
                                    rules={[{ required: true, message: 'Isi tanggal sampai' }]}
                                >
                                    <DatePicker
                                        placeholder="dd-mm-yyyy"
                                        format="DD-MM-YYYY"
                                        style={{ width: '100%' }}
                                        onChange={(_, dateString) => {
                                            this.formRef.current.setFieldsValue({ sampai_dengan: dateString });
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item name="sampai_dengan" style={{ display: 'none' }}>
                                    <Input type="hidden" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    {/* ── Persentase Diskon ───────────────────── */}
                    <Card
                        style={{ marginBottom: 16, borderRadius: 8, border: '1px solid #f0f0f0' }}
                        title={
                            <Space>
                                <PercentageOutlined style={{ color: '#722ed1' }} />
                                <Text strong style={{ fontSize: 13 }}>Persentase Diskon</Text>
                            </Space>
                        }
                        headStyle={{ background: '#fafafa', borderRadius: '8px 8px 0 0', minHeight: 40 }}
                    >
                        <Row gutter={[12, 12]}>
                            {PERSEN_GROUPS.map((group) => (
                                <Col key={group.label} lg={12} md={12} sm={24} xs={24}>
                                    <div style={{
                                        borderRadius: 8,
                                        border: `1px solid ${group.color}33`,
                                        background: group.bg,
                                        padding: '10px 14px',
                                    }}>
                                        <div style={{ marginBottom: 10 }}>
                                            <Tag
                                                color={group.color}
                                                style={{ borderRadius: 4, fontWeight: 600, fontSize: 11 }}
                                            >
                                                {group.label}
                                            </Tag>
                                        </div>
                                        <Row gutter={8}>
                                            {group.fields.map((f) => (
                                                <Col key={f.name} xs={24} sm={12}>
                                                    <Form.Item
                                                        label={<Text style={{ fontSize: 12 }}>{f.label}</Text>}
                                                        name={f.name}
                                                        rules={[{ required: true, message: 'Harus diisi' }]}
                                                        style={{ marginBottom: 0 }}
                                                    >
                                                        <InputNumber
                                                            min={0}
                                                            max={100}
                                                            step={0.01}
                                                            precision={2}
                                                            addonAfter="%"
                                                            style={{ width: '100%' }}
                                                            placeholder="0.00"
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            ))}
                                        </Row>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Card>

                    {/* ── Kondisi Lainnya ─────────────────────── */}
                    <Card
                        style={{ marginBottom: 16, borderRadius: 8, border: '1px solid #f0f0f0' }}
                        title={
                            <Space>
                                <CarOutlined style={{ color: '#fa8c16' }} />
                                <Text strong style={{ fontSize: 13 }}>Kondisi Lainnya</Text>
                            </Space>
                        }
                        headStyle={{ background: '#fafafa', borderRadius: '8px 8px 0 0', minHeight: 40 }}
                    >
                        <Row gutter={[16, 8]}>
                            {SWITCH_FIELDS.map((f) => (
                                <Col key={f.name} xs={24} sm={12} lg={6}>
                                    <div style={{
                                        borderRadius: 8,
                                        border: `1px solid ${f.color}33`,
                                        padding: '10px 14px',
                                        background: `${f.color}08`,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: 8,
                                    }}>
                                        <Text style={{ fontSize: 12, fontWeight: 500, color: f.color }}>
                                            {f.label}
                                        </Text>
                                        <Switch
                                            checked={this.state[f.name]}
                                            checkedChildren="Ya"
                                            unCheckedChildren="Tidak"
                                            style={{ backgroundColor: this.state[f.name] ? f.color : undefined }}
                                            onChange={(isChecked) => {
                                                this.setState({ [f.name]: isChecked });
                                                this.formRef.current.setFieldsValue({ [f.name]: isChecked });
                                            }}
                                        />
                                        <Form.Item name={f.name} style={{ display: 'none', margin: 0 }}>
                                            <Input type="hidden" />
                                        </Form.Item>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Card>

                    {/* ── Tombol bawah ─────────────────────────── */}
                    <Card
                        style={{ borderRadius: 8, border: '1px solid #f0f0f0' }}
                        bodyStyle={{ padding: '12px 16px' }}
                    >
                        <Row gutter={[8, 8]} justify="end">
                            <Col xs={12} sm="auto">
                                <Link to={configClass.pageUrl.data}>
                                    <Button icon={<CloseCircleOutlined />} size="large" disabled={this.state.loadingButton} style={{ width: '100%', borderRadius: 10 }}>
                                        Batal
                                    </Button>
                                </Link>
                            </Col>
                            <Col xs={12} sm="auto">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    icon={<SaveOutlined />}
                                    size="large"
                                    loading={this.state.loadingButton}
                                    disabled={this.state.errComponent}
                                    style={{ width: '100%', borderRadius: 10, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', fontWeight: 600 }}
                                >
                                    {isEdit ? 'Perbarui Data' : 'Simpan Data'}
                                </Button>
                            </Col>
                        </Row>
                    </Card>

                </Form>
            </div>
        );
    }
}

const mapStateToProps = (state) => state.configReducers;

export default connect(
    mapStateToProps,
    { initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(FormDiskon);
